module.exports = __webpack_public_path__ + "assets/img/TopTradedBAIOS.8a374907.png";